import React, { useState } from 'react';

import { Button } from '@components/common';
import Spinner from '@components/common/Spinner';

import { Icons } from '@icons/icons';

import { uuid } from '@utils/common';

import colors from '@constants/colors';
import { spinnerColors, spinners } from '@components/common/Spinner/constants';

import styles from './SelectSpinnerModal.module.scss';

interface ISelectSpinnerModal {
	prevSpinnerId: number;
	prevSpinnerColorId: number;
	closeModal: () => void;
	proceedSpinnerColorId: (id: number) => void;
	proceedSpinnerId: (id: number) => void;
}

const SelectSpinnerModal = ({
	prevSpinnerColorId,
	prevSpinnerId,
	closeModal,
	proceedSpinnerId,
	proceedSpinnerColorId,
}: ISelectSpinnerModal) => {
	const [selectedSpinnerId, setSelectedSpinnerId] = useState<number>(prevSpinnerId);
	const [selectedSpinnerColorId, setSelectedSpinnerColorId] = useState<number>(prevSpinnerColorId);

	const selectSpinner = (id: number) => () => setSelectedSpinnerId(id);

	const selectColor = (id: number) => () => setSelectedSpinnerColorId(id);

	const onProceed = () => {
		proceedSpinnerId(selectedSpinnerId);
		proceedSpinnerColorId(selectedSpinnerColorId);

		closeModal();
	};

	return (
		<div className={styles.selectSpinnerModal}>
			<div className={styles.spinnersContainer}>
				{spinners.map((spinner, index) => {
					return (
						<div
							key={uuid()}
							className={styles.spinnerContainer}
							onClick={selectSpinner(spinner.id)}
							style={{
								backgroundColor: index % 2 ? '#FDFDFD' : colors.gray04,
								border: selectedSpinnerId === spinner.id
									? `2px solid ${colors.indigo50}`
									: 'unset',
								borderRadius: selectedSpinnerId === spinner.id
									? `5px`
									: 'unset',
							}}
						>
							<Spinner
								size={28}
								spinnerColorId={selectedSpinnerColorId}
								spinnerId={spinner.id}
							/>
						</div>
					);
				})}
			</div>
			<div className={styles.colorsContainer}>
				<div className={styles.colorLabel}>Color:</div>
				{spinnerColors.map(spinnerColor => {
					return (
						<div
							key={uuid()}
							className={styles.colorCell}
							onClick={selectColor(spinnerColor.id)}
							style={{
								backgroundColor: spinnerColor.color,
							}}
						>
							{spinnerColor.id === selectedSpinnerColorId && Icons.checkMarkWhite()}
						</div>
					);
				})}
			</div>
			<div className={styles.submitButtons}>
				<Button
					onClick={closeModal}
					text='Cancel'
					withoutBackground
				/>
				<Button
					className={styles.proceedButton}
					large
					onClick={onProceed}
					text='Proceed'
				/>
			</div>
		</div>
	);
};

export default SelectSpinnerModal;
